import styled from 'styled-components'

const MyDiv = styled.div`
.page_heading{
    margin-bottom: 10px;
}

`
export default MyDiv
